import NtxTable from '@components/DataTable/NtxTable';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const All = ({ Persons, onIdsChange }) => {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (Persons?.length && onIdsChange) {
      const ids = Persons?.filter(f => !f.hasRun)?.map(p => p.assignmentId);
      onIdsChange(ids);
    }
  }, [Persons, onIdsChange]);

  const columns = [
    {
      // title: <input className='form-check-input' type='checkbox' checked={true} readOnly />,
      title: (
        <input
          className='form-check-input'
          type='checkbox'
          checked={!Persons?.some(item => !item.hasRun)}
          readOnly
        />
      ),
      key: 'checkBox',
      sortable: false
    },
    { title: t('EmployeeName'), key: 'Name' },
    { title: t('EmployeeNumber'), key: 'num' },
    { title: t('Payroll'), key: 'Payroll' },
    { title: t('Status'), key: 'hasRun' }
  ];

  const tableData = Persons?.map(item => {
    return {
      checkBox: (
        <input
          className='form-check-input'
          type='checkbox'
          checked={item.hasRun ? false : true}
          readOnly
          // onChange={() => handleCheckboxChange(item.assignmentId)}
        />
      ),
      Name: i18n.language === 'ar' ? item.personName2 : item.personName,
      num: item.employeeNumber,
      Payroll: i18n.language === 'ar' ? item.payrollName2 : item.payrollName,
      hasRun: (
        <div className='d-flex align-items-center'>
          <span className={`badge ${item.hasRun ? 'bg-success' : 'bg-danger'} me-2`}>
            {item.hasRun ? t('Paid') : t('Unpaid')}
          </span>
        </div>
      )
    };
  });

  return (
    <>
      <NtxTable
        data={tableData || []}
        columns={columns}
        dataPerPage={10}
        theadClass=''
        tableClass='table text-nowrap table-hover '
        enableSearch
        showRecordsSelector
      />
    </>
  );
};

export default All;
